import React, { useState } from "react";
import DataTable from "../../components/DataTable";
import PageWrapperForm from "../../components/PageWrapperForm";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { SchemeManagement } from "../../config/tableConfigs";
import SchemeFormModal from "./components/schemeFormModal";
import DeleteModal from "../../components/DeleteModal";
import { useSession } from "hooks/useSession";

const SchemeManagementPage = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh] = useState(0); 
  const {userid} = useSession(); // 🔄 trigger refresh

  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid",userid );

  const tableData = useTableDataWithPost(
    "https://api.mokshiq.in/scheme_manager_action",
    SchemeManagement,
    formdata,
    refresh // 👈 hook re-fetches when refresh changes
  );

  const handleView = (report) => {
    console.log("Viewing report:", report);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setModalShow(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deletescheme1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)) {
      console.log("Deleting selected records:", selectedIds);
      // call delete API → then refresh
      setRefresh((prev) => prev + 1);
    }
  };

  // ✅ Handle successful form submission
  const handleFormSuccess = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setModalShow(false)
  };

  // ✅ Handle successful deletion
  const handleDeleteSuccess = () => {
    console.log("Scheme deleted successfully, refreshing data...");
    setRefresh((prev) => prev + 1);
  };

  return (
    <div>
      <PageWrapperForm
        config={SchemeManagement}
        handleOnclick={handleAddUser}
        buttonTitle={"Add Scheme"}
      >
        <DataTable
          config={SchemeManagement}
          tableData={tableData}
          onView={handleView}
          onEdit={handleEditUser}
          onDelete={handleDelete}
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>

      <SchemeFormModal
        show={modalShow}
        onClose={() => setModalShow(false)} // ✅ Just close modal, don't refresh here
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess} // ✅ Pass success callback
      />

      <DeleteModal
        deleteid={selectedUser}
        id="deletescheme1"
        title="Delete Scheme"
        message="Are you sure you want to delete this scheme?"
        apiUrl="https://api.mokshiq.in/scheme_manager_action"
        onSuccess={handleDeleteSuccess} // ✅ Pass success callback
      />
    </div>
  );
};

export default SchemeManagementPage;